<template>
  <router-view/>
</template>

<script>
export default {
  name: 'DocHub'
}
</script>
